// ── Fire-gathering messages (AGE-1333 Phases A–C) ──
//
// Campfire (intimate, 6 seats) and bonfire (festive, 12–16 seats) are
// interactive world objects within OverworldScene. Server-authoritative
// seat state; client renders based on messages. Sitting at a fire
// transitions attendance to ParkedHearth with a fire-prefixed structureId.
// ── Phase A — sit/stand ──
/** Client → Server: player requests to sit at a fire. */
export const MSG_FIRE_SIT = 'fire_sit';
/** Server → All: player has sat down at a fire seat. */
export const MSG_FIRE_SAT = 'fire_sat';
/** Client → Server: player requests to stand up from a fire. */
export const MSG_FIRE_STAND = 'fire_stand';
/** Server → All: player has stood up from a fire. */
export const MSG_FIRE_STOOD = 'fire_stood';
// ── Phase B — marshmallow roasting (campfire only) ──
/** Client → Server: player begins roasting a marshmallow. */
export const MSG_MARSHMALLOW_ROAST_START = 'marshmallow_roast_start';
/** Server → Client: tick update on roast progress (0..1). */
export const MSG_MARSHMALLOW_ROAST_TICK = 'marshmallow_roast_tick';
/** Server → Client: marshmallow roast completed. */
export const MSG_MARSHMALLOW_ROAST_COMPLETE = 'marshmallow_roast_complete';
// ── Phase C — bonfire festivity ──
/** Client → Server: player triggers a fire emote. */
export const MSG_FIRE_EMOTE = 'fire_emote';
/** Server → All: fire emote played by a player. */
export const MSG_FIRE_EMOTE_PLAYED = 'fire_emote_played';
// ── Constants ──
/** Campfire seat count. */
export const CAMPFIRE_SEATS = 6;
/** Bonfire seat count. */
export const BONFIRE_SEATS = 16;
/** Cartesian-pixel proximity radius for fire sit prompt. */
export const FIRE_SIT_PROXIMITY = 96;
/** Roast timer in ms (3 seconds). */
export const MARSHMALLOW_ROAST_DURATION_MS = 3000;
/** Golden window: 2.5s–3.5s. */
export const MARSHMALLOW_GOLDEN_MIN_MS = 2500;
export const MARSHMALLOW_GOLDEN_MAX_MS = 3500;
/** Charred threshold: >4s. */
export const MARSHMALLOW_CHARRED_MS = 4000;
/** Bonfire group buff: minimum seated players to activate. */
export const BONFIRE_BUFF_MIN_PLAYERS = 4;
/** Bonfire Spirit buff duration in ms (30 minutes). */
export const BONFIRE_SPIRIT_DURATION_MS = 30 * 60 * 1000;
/** Bonfire Spirit move speed multiplier. */
export const BONFIRE_SPIRIT_SPEED_MULT = 1.1;
//# sourceMappingURL=fire.js.map